module.exports = __webpack_public_path__ + "static/Hourly-d4c553bd4890634bb0940cd68d2f3fef.jpg";